import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const Confirm = ({ show, toggle, title, children, confirm }) => {
  return (
    <Modal isOpen={show} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <button className="btn btn-danger" onClick={toggle}>
          <i className="fa fa-times-circle" /> No
        </button>

        <button type="submit" className="btn btn-success" onClick={confirm}>
          <i className="fa fa-check-circle" /> Yes
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/Modals/Confirm.jsx